import React, { useEffect, useState, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import TR from '../../Trans';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ErrorDialog from '../dialogs/ErrorDialog';
import Box from '@mui/material/Box';
import { GlobalStyles } from "@mui/material";
import backgroundImage from "../../assets/people-group-4-square.jpg";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useNavigate } from "react-router-dom";
import { ReactComponent as MuvikaLogo } from './../../assets/logo.svg';
import { useLocalStorage } from '../../services/useLocalStorage';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import { ReactComponent as MuvikaLogoProInv } from './../../assets/logo-horiz-pro-inv.svg';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IosExternalLinkDialog from '../dialogs/IosExternalLinkDialog';
import CssBaseline from '@mui/material/CssBaseline';
import { Capacitor } from '@capacitor/core';
import TermsDialog from '../dialogs/TermsDialog';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import FacebookLoginDialog from '../dialogs/FacebookLoginDialog';
import InputAdornment from '@mui/material/InputAdornment';
import Error from '../items/Error';
import ChooseLanguage from '../items/ChooseLanguage';
import Message from '../items/Message';
import Container from '@mui/material/Container';
import Waiting from '../items/Waiting';
import sessionStore from '../../stores/session';
import messageStore from '../../stores/message';
import statusStore from '../../stores/status';
import accountStore from '../../stores/account';
import { Logout } from '@mui/icons-material';
import MuvikaService from '../../services/muvika';
import IntervalService from '../../services/intervals';
import navigationStore from '../../stores/navigation';
import performanceStore from '../../stores/performance';
import settingsStore from '../../stores/settings';
import ThemeToggleButton from '../items/ThemeToggleButton';
import singersStore from '../../stores/singers';
import EditPerformance from '../dialogs/EditPerformance';
import newTracksStore from '../../stores/newTracks';
import favoritesStore from '../../stores/favorites';
import catalogStore from '../../stores/catalog';
import environmentStore from '../../stores/environment';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import newsStore from '../../stores/news';
import playerStore from '../../stores/player';
import searchStore from '../../stores/search';
import songListStore from '../../stores/songList';
import singerStore from '../../stores/singers';
import timeoutsStore from '../../stores/timeouts';
import homeStore from '../../stores/home';
import SubscribeDialog from '../dialogs/SubscriptionDialog';
import UpdateDialog from '../dialogs/UpdateDialog';
import MessageDialog from '../dialogs/MessageDialog';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import muvikaAttrs from '../../attrs';
import bgFiltersStore from '../../stores/bgFilters';
import bgStylesStore from '../../stores/bgStyles';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgSearchStore from '../../stores/bgSearch';
import bgPlaylistsStore from '../../stores/bgPlaylists';
import songbookQueueStore from '../../stores/songbookQueue';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "var(--back-color)"
    }
  },
});

function resetStores() {
  accountStore.getState().reset();
  catalogStore.getState().reset();
  environmentStore.getState().reset();
  favoritesStore.getState().reset();
  messageStore.getState().reset();
  musicPlayerStore.getState().reset();
  musicStore.getState().reset();
  navigationStore.getState().reset();
  newsStore.getState().reset();
  homeStore.getState().reset();
  newTracksStore.getState().reset();
  performanceStore.getState().reset();
  playerStore.getState().reset();
  searchStore.getState().reset();
  sessionStore.setState({
    isSessionOpening: false,
    isThrownOut: false,
    isLoggedIn: false,
    isAckSmartQ: false,
    externalWindowHandler: null,
    isLoginSeqErrors: false,
    isLoginSeqError: false,
    isWaiting: false,
    requestCount: 0,
    isWaitingLoggedIn: false,
    isAndroidSubMode: false
  });
  settingsStore.getState().reset();
  singersStore.getState().reset();
  songListStore.getState().reset();
  timeoutsStore.getState().reset();
  IntervalService.clearAllIntervals();
  IntervalService.clearAllStreamUrlTimeouts();
  IntervalService.clearSongbookInterval();
  IntervalService.clearNewTracksInterval();
  IntervalService.clearSubInterval();
  bgFiltersStore.getState().reset();
  bgStylesStore.getState().reset();
  bgPerformanceStore.getState().reset();
  bgSearchStore.getState().reset();
  bgPlaylistsStore.getState().reset();
  musicPlayerStore.getState().reset();
  
}

function ForceAcceptTerms() {

  useEffect(() => {
    document.documentElement.style.fontSize = "16px";
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, []);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const getAccount = accountStore((state) => state.getAccount);
  const setAccount = accountStore((state) => state.setAccount);
  const account = accountStore((state) => state.account);
  const environment = environmentStore((state) => state.environment);
  const clearAccountStore = accountStore((state) => state.clearAll);
  const logout = sessionStore((state) => state.logout);
  const isSessionOpen = sessionStore((state) => state.isSessionOpen);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);
  const setError = messageStore((state) => state.setError);
  const setMessage = messageStore((state) => state.setMessage);
  const updateSession = sessionStore((state) => state.updateSession);

  useEffect(() => {
    if (!account) {
      getAccount(sessionToken);
    }
  }, []);

  const handleAcceptTerms = (areTermsAccepted) => {
    if (areTermsAccepted) {
      let newAccount = { ...account };
      newAccount.force_accept_terms = 0;
      setAccount(sessionToken, newAccount);
    } else {
      setError(sessionToken, 0, TR.cm_check_terms_and_conditions);
    }
  };

  const [isTermsDialogOpen, setIsTermsDialogOpen] = useState(false);

  const handleOpenTermsDialog = (e) => {
    e.preventDefault();
    setIsTermsDialogOpen(true);
  };

  const handleCloseTermsDialog = () => {
    setIsTermsDialogOpen(false);
  };

  const [areTermsAccepted, setAreTermsAccepted] = useState(false);

  const handleTermsSet = (event) => {
    setAreTermsAccepted(event.target.checked);
  };

  const handleChange = () => {
    handleAcceptTerms(areTermsAccepted);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleChange();
    }
  };

  const renderTerms = () => {
    if (account) {
      if (account.force_accept_terms) {
        return <p>
          <FormControlLabel onChange={handleTermsSet} required control={<Checkbox />} />
          <span>
            {TR.cm_i_have_read_and_agree}
            {" "}
            <a href="#" onClick={(e) => handleOpenTermsDialog(e)} target="_blank">
              {TR.cm_terms_and_conditions.toLocaleLowerCase()}
            </a>
          </span>
        </p>;
      }
    }
  };

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-theme", "dark");

  const renderLogo = () => {
    if (!theme || theme === "dark") {
      return <MuvikaLogo className="muvika-logo-login-svg" />;
    } else {
      return <MuvikaLogoInv className="muvika-logo-login-svg" />;
    }
  };

  const renderLoggedIn = () => {
    if (isSessionOpen && isLoggedIn) {
      if (account) {
        if (account.force_accept_terms) {
          return <Box
            className="muvika-entry-box"
          >
            <p>
              {renderLogo()}
            </p>
            {renderTerms()}
            <Stack direction="row" spacing={6} justifyContent="center">
              <Button variant="text" color="secondary" onClick={() => {
                resetStores();
                logout();
              }}>{TR.cm_cancel}</Button>
              <Button
                variant="text"
                color="success"
                onClick={handleChange}
              >
                {TR.cm_save}
              </Button>
            </Stack>
            <ThemeToggleButton />
          </Box>;
        } else {
          return <Navigate to="/" />;
        }
      }
    } else {
      return <Navigate to="/" />;
    }
  };

  const renderTermsDialog = () => {
    return <TermsDialog
      open={isTermsDialogOpen}
      onClose={handleCloseTermsDialog}
      title={TR.cm_terms_and_conditions}
      url={environment ? environment.urls.url_terms_home : ""}
    />;
  };

  const overflowStyleIos = `
  html {
    overflow-y:scroll !important;
  }
  
  body {
    overflow-y:scroll !important;
  }
  
  main {
    overflow-y:scroll !important;
  }
`;

  const overflowStyle = `
  html {
    overflow-y:auto !important;
  }
  
  body {
    overflow-y:auto !important;
  }
  
  main {
    overflow-y:auto !important;
  }
`;

  const renderOverflowStyle = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return <style>
        {overflowStyleIos}
      </style>;
    } else {
      return <style>
        {overflowStyle}
      </style>;
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      {renderOverflowStyle()}
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            minHeight: "100vh",
            minWidth: "100vw",
            backgroundImage: `url(${backgroundImage}) !important`,
            backgroundRepeat: "no-repeat !important",
            backgroundSize: "cover !important",
            backgroundPosition: "center !important",
          },
        }}
      />
      <Container component="main" className="muvika-entry-container" maxWidth="xs" onKeyDown={handleKeyDown}>
        <CssBaseline />
        <Error />
        <Message />
        {renderTermsDialog()}
        {renderLoggedIn()}
      </Container>
    </ThemeProvider>
  );
}

export default ForceAcceptTerms;